import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '../../../components/Button.js';
import UserFeaturesCTA from '../../../components/widgets/UserFeaturesCTA';

const useStyles = makeStyles({
  root: {
    padding: '1rem',
    maxWidth: '45rem',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  header: {
    marginBottom: '1.5rem',
  },
  text: {
    padding: '0.5rem 0',
    textAlign: 'center',
    marginBottom: '1.5rem',
  },
});

const RequestComplete = ({completeButtonLabel, completeButtonTo, requestId}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography variant="h2" color="primary" className={classes.header}>
        Completed!
      </Typography>
      <Typography variant="h3" className={classes.text}>
        Thank you for choosing Clickability, we&apos;ll be in touch with more information about your request soon. Your request ID is <b>{requestId}</b>.
      </Typography>
      <Typography variant="h3" className={classes.text}>
        If you need help, you can speak to our friendly team by calling <b>1800 414 616</b>.
      </Typography>
      <UserFeaturesCTA />
      <Button
        label={completeButtonLabel}
        to={completeButtonTo}
        pointer="right"
        variant="contained"
        style={{marginTop: '1.5rem', minWidth: '10rem'}}
      />
    </div>
  );
};

RequestComplete.propTypes = {
  completeButtonLabel: PropTypes.string.isRequired,
  completeButtonTo: PropTypes.string.isRequired,
  requestId: PropTypes.string.isRequired,
};

export default RequestComplete;
